import * as service from '../../agent/routers/cliJsCode/service';
import { StepAction } from './stepAction';
import { NpmPackageError, TimeoutError } from '../../errors';
import type { RunContext } from './stepAction';
import type { Step } from 'clickim/src/common/models/step';

export interface NodePackageStepActionContext extends RunContext {
    stepId: string;
    packageData: { packageName: string; packageVersion: string; targetId: string; targetName: string }[];
    resultId: string;
    retryIndex: number;
    timeToPlayBeforeExec: number;
}
export class NodePackageStepAction extends StepAction<Step, NodePackageStepActionContext> {
    override async performAction() {
        const { stepId, packageData, resultId, retryIndex, stepResultId, timeToPlayBeforeExec } = this.context;

        try {
            const data = await service.installPackage(
                stepId,
                resultId,
                retryIndex,
                packageData,
                stepResultId!,
                timeToPlayBeforeExec,
            );
            return { data, success: true };
        } catch (err) {
            if (err instanceof NpmPackageError) {
                return {
                    success: false,
                    code: 'invalid-node-package',
                    message: err.message,
                };
            }
            if (err instanceof TimeoutError) {
                return {
                    success: false,
                    code: 'timeout',
                };
            }
            return {
                success: false,
                reason: err.message,
                exception: err,
            };
        }
    }
}
